export const getPartyAbbreviation = (registered_party: string) => {
  const party = registered_party?.trim().toLowerCase();

  const abbrevs: { [key: string]: string } = {
    republican: 'Rep',
    'modeled republican': 'Rep',

    democrat: 'Dem',
    democratic: 'Dem',
    'modeled democrat': 'Dem',

    'unaffiliated/dts': 'DTS',
    'modeled independent/unaffiliated': 'Ind',
    'independent/other': 'Ind',
  };

  return abbrevs[party] || 'Ind';
};
